import React from 'react';

/**
 * useContent like hook effect
 *
 * @export
 */
export function useContent(content) {
    const { id, title, release, duration = 0, flights, genres, participants, description, ratings, contentType, entitlementTypes, ratingDescriptors } = content ?? {};
    const { director: arrayDirector, cast: arayCast } = participants ?? {};
    const [{ flights: arrayFlightsStartEnd }] = flights ?? [{}];
    const [{ start, end: endFlight }] = arrayFlightsStartEnd ?? [{}];
    return {
        id,
        title, 
        release, 
        duration, 
        flights, 
        genres, 
        participants, 
        description, 
        ratings, 
        contentType, 
        entitlementTypes,
        arrayDirector,
        arayCast,
        arrayFlightsStartEnd,
        start,
        endFlight,
        ratingDescriptors
    } 
}